import { render, staticRenderFns } from "./FighterGrid.vue?vue&type=template&id=09cf3b66&scoped=true"
import script from "./FighterGrid.vue?vue&type=script&lang=js"
export * from "./FighterGrid.vue?vue&type=script&lang=js"
import style0 from "./FighterGrid.vue?vue&type=style&index=0&id=09cf3b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf3b66",
  null
  
)

export default component.exports